module.exports = __webpack_public_path__ + "img/helm_of_the_dominator.1c3de265.png";